import { render, staticRenderFns } from "./top-header.vue?vue&type=template&id=3f083894&scoped=true&"
var script = {}
import style0 from "./top-header.vue?vue&type=style&index=0&id=3f083894&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f083894",
  null
  
)

export default component.exports